export default __webpack_public_path__ + "static/media/AdminLearningCenterPicture.0a9c1000.jpg";